import React, { Component } from "react";

import { setDepthOfPit } from "util/aws-manager";
import Button from "material-ui/Button";
import {
  getAllConfiguration,
  getPitDepth,
  setAllConfiguration,
} from "util/aws-manager";
import {
  CardText,
} from "reactstrap";
import SearchBox from "components/SearchBox";
import { searchDevices } from "util/aws-manager";
import moment from "moment";
import { connect } from "react-redux";
import _ from "lodash";
import SearchModal from "./searchModal";

class Config extends Component {
  constructor(props) {
    super(props);
    this.state = {
      depthOfPit: "",
      pitDepth: "",
      sensorReadInterval: "",
      transmitInterval: "",
      batteryReadInterval: "",
      currentSensorRead: "",
      temperatureProbes: "",
      deviceId: "",
      options: [],
      selected: [],
      searchText: "",
      configurationValues: {},
      searchToggle: false,
    };
  }

  dropdownToggle = () => {
    if (this.state.options.length > 0) {
      this.setState({
        searchToggle: !this.state.searchToggle,
      });
    }
  };

  onChangeDepth = (event) => {
    if (!isNaN(event.target.value)) {
      this.setState({
        depthOfPit: event.target.value,
      });
    }
  };

  onChangeSensorRead = (event) => {
    if (!isNaN(event.target.value)) {
      this.setState({
        sensorReadInterval: event.target.value,
      });
    }
  };

  onChangeTransmitInterval = (event) => {
    if (!isNaN(event.target.value)) {
      this.setState({
        transmitInterval: event.target.value,
      });
    }
  };

  onChangeBatteryLevelRead = (event) => {
    if (!isNaN(event.target.value)) {
      this.setState({
        batteryReadInterval: event.target.value,
      });
    }
  };

  onChangeCurrentSensorRead = (event) => {
    if (!isNaN(event.target.value)) {
      this.setState({
        currentSensorRead: event.target.value,
      });
    }
  };

  onChangeTemperatureProbes = (event) => {
    if (!isNaN(event.target.value)) {
      this.setState({
        temperatureProbes: event.target.value,
      });
    }
  };

  filterObject = (object) => {
    for (var propName in object) {
      if (
        object[propName] === "" ||
        object[propName] === null ||
        object[propName] === undefined
      ) {
        delete object[propName];
      }
    }
    return object;
  };

  componentDidMount() {
    this.getAllConfiguration();
    this.getPitDepth();
  }

  getSearchedDevices = () => {
    if (this.state.searchText !== "") {
      searchDevices(this.state.searchText)
        .then((data) => {
          const uniqueRecords = data.filter(this.unique);
          const records = uniqueRecords.map((item) => {
            return item;
          });

          const concatRecords = this.state.selected.concat(records);
          const uniqueList = _.uniqWith(concatRecords, _.isEqual);
          this.setState({
            options: uniqueList,
          });
        })
        .catch((error) => {
          console.log("error: ", error);
        });
    }
  };

  getPitDepth = () => {
    getPitDepth(this.props.deviceId)
      .then((item) => {
        this.setState({
          pitDepth: item.pitDepth,
        });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  formatDate = (item) => {
    return `( ${moment(item * 1000).format("DD-MM-YYYY hh:mm:ss")} )`;
  };

  getAllConfiguration = () => {
    getAllConfiguration(this.props.deviceId)
      .then((item) => {
        this.setState({
          configurationValues: item,
          // {
          //   sensors: { status: "PENDING", device: 10, value: 20 },
          //   network: { status: "PENDING", device: 20, value: 30 },
          //   maintenance: { status: "PENDING", device: 30, value: 40 },
          //   current: { status: "PENDING", device: 40, value: 50 },
          //   probes: { status: "PENDING", device: 50, value: 60 },
          // },
        });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  unique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  saveAllConfiguration = () => {
    let message;
    const {
      sensorReadInterval,
      transmitInterval,
      batteryReadInterval,
      currentSensorRead,
      temperatureProbes,
    } = this.state;
    const data = {
      sensors: sensorReadInterval,
      network: transmitInterval,
      maintenance: batteryReadInterval,
      current: currentSensorRead,
      probes: temperatureProbes,
    };
    const item = this.filterObject(data);
    const length = Object.keys(item).length;
    if (length > 0) {
      setAllConfiguration(this.props.deviceId, item)
        .then((data) => {
          console.log("data: ", data);
          message = "Configuration updated successfully";
          alert(message);
          this.getAllConfiguration();
          this.setState({
            sensorReadInterval: "",
            transmitInterval: "",
            batteryReadInterval: "",
            currentSensorRead: "",
            temperatureProbes: "",
          });
        })
        .catch((error) => {
          message = "Unable to update configuration";
          alert(message);
          console.log("error: ", error);
        });
    }
  };

  renderImage = (active) => {
    if (active) {
      return (
        <img
          className="battery-charge-img d-inline-block pl-0"
          src="../../../../assets/images/online.png"
          alt="Online"
          style={{
            borderRadius: 15,
            marginLeft: 10,
          }}
          width={15}
          height={15}
        />
      );
    }
    return (
      <img
        className="battery-charge-img d-inline-block pl-0"
        src="../../../../assets/images/redIc.png"
        alt="Offline"
        width={15}
        style={{
          borderRadius: 15,
          marginLeft: 10,
        }}
        height={15}
      />
    );
  };

  saveDepthOfPit = () => {
    let message;
    setDepthOfPit(this.props.deviceId, this.state.depthOfPit)
      .then((data) => {
        this.getPitDepth();
        this.setState({
          depthOfPit: "",
        });
        message = "Depth updated successfully";
        alert(message);
      })
      .catch((error) => {
        message = "Unable to set depth";
        console.log("error: ", error);
      });
  };

  render() {
    const {
      depthOfPit,
      sensorReadInterval,
      transmitInterval,
      batteryReadInterval,
      currentSensorRead,
      temperatureProbes,
      configurationValues,
    } = this.state;
    // const depthActive =
    //   parseFloat(depthOfPit) === parseFloat(currentValue.depthOfPit);
    const sensorReadActive =
      parseFloat(
        configurationValues.sensors && configurationValues.sensors.reported
      ) ===
        parseFloat(
          configurationValues.sensors && configurationValues.sensors.desired
        ) ||
      (configurationValues.sensors &&
        configurationValues.sensors.status === "UPDATED");
    const transmitIntervalActive =
      parseFloat(
        configurationValues.network && configurationValues.network.reported
      ) ===
        parseFloat(
          configurationValues.network && configurationValues.network.desired
        ) ||
      (configurationValues.network &&
        configurationValues.network.status === "UPDATED");
    const batteryReadActive =
      parseFloat(
        configurationValues.maintenance &&
          configurationValues.maintenance.reported
      ) ===
        parseFloat(
          configurationValues.maintenance &&
            configurationValues.maintenance.desired
        ) ||
      (configurationValues.maintenance &&
        configurationValues.maintenance.status === "UPDATED");
    const currentSensorActive =
      parseFloat(
        configurationValues.current && configurationValues.current.reported
      ) ===
        parseFloat(
          configurationValues.current && configurationValues.current.desired
        ) ||
      (configurationValues.current &&
        configurationValues.current.status === "UPDATED");
    const temperatureProbeActive =
      parseFloat(
        configurationValues.probes && configurationValues.probes.reported
      ) ===
        parseFloat(
          configurationValues.probes && configurationValues.probes.desired
        ) ||
      (configurationValues.probes &&
        configurationValues.probes.status === "UPDATED");
    const disabled =
      depthOfPit === "" &&
      sensorReadInterval === "" &&
      transmitInterval === "" &&
      batteryReadInterval === "" &&
      currentSensorRead === "" &&
      temperatureProbes === "";
    const uniqueList = _.uniqWith(this.state.selected, _.isEqual);
    return (
      <div className="row configuration-page">
        <div className="col-12">
          <div className="jr-card d-sm-flex justify-content-sm-between align-items-sm-center">
            <div className="col-12 col-sm-6 col-lg-8">
              <h1 className="mb-0">OTA Update</h1>
            </div>
            <div className="col-12 col-sm-6 col-lg-4">
              Device ID: {this.props.deviceId}
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-12 col-sm-12 col-lg-12 col-xl-8">
              <div className="row card-height">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="jr-card h-100">
                    <div className="col-12 d-flex justify-content-end">
                      <Button
                        disabled={disabled}
                        onClick={async () => {
                          if (this.state.depthOfPit !== "") {
                            await this.saveDepthOfPit();
                          }
                          this.saveAllConfiguration();
                        }}
                        variant="raised"
                        color={disabled ? "default" : "primary"}
                        className="jr-btn text-white mt-2"
                      >
                        SAVE CHANGES
                      </Button>
                    </div>
                    <div className="row">
                      <div
                        className="col-12 col-lg-4 px-0"
                        style={{
                          border: "1px solid #ccc",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginLeft: 12,
                          marginRight: 12,
                          borderRadius: 5,
                        }}
                      >
                        <SearchBox
                          styleName="col-12 d-sm-block px-0"
                          placeholder="Search by Device ID"
                          onChange={(text) => {
                            this.setState({
                              searchText: text.target.value,
                            });
                          }}
                          value={this.state.searchText}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              this.getSearchedDevices();
                              $("#searchModalComponent").modal();
                            }
                          }}
                          onButtonClick={() => {
                            this.getSearchedDevices();
                            $("#searchModalComponent").modal();
                          }}
                        />
                        <SearchModal
                          selectAll={(checked) => {
                            // let data = this.state.options;
                            // if (checked) {
                            //   data = this.state.options;
                            // } else {
                            //   data = [];
                            // }
                            // this.setState({
                            //   selected: data,
                            // });
                          }}
                          data={this.state.options}
                          searchText={this.state.searchText}
                          onChangeText={(text) => {
                            this.setState({
                              searchText: text.target.value,
                            });
                          }}
                          selected={this.state.selected}
                          searchDevices={() => {
                            this.getSearchedDevices();
                          }}
                          selectDevice={(data) => {
                            const item = this.state.selected;
                            const isExist = item.findIndex(
                              (res) => res === data
                            );
                            if (isExist !== -1) {
                              item.splice(isExist, 1);
                            } else {
                              item.push(data);
                            }
                            this.setState({
                              selected: item,
                            });
                          }}
                        />
                      </div>
                    </div>
                    {uniqueList.length > 0 && (
                      <div
                        className="col-12"
                        style={{
                          border: "1px solid #ccc",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 5,
                          marginTop: 10,
                          marginBottom: 10,
                          padding: 10,
                        }}
                      >
                        <div className="col-12">
                          {uniqueList.map((data, index) => {
                            return (
                              <span
                                className="pr-2"
                                style={{
                                  color: "#1E90FF",
                                }}
                                key={index}
                                onClick={() => {
                                  const filter = this.state.selected;
                                  filter.splice(
                                    filter.findIndex((item) => item === data),
                                    1
                                  );
                                  this.setState({
                                    selected: filter,
                                  });
                                }}
                              >
                                {data}
                                <i className="zmdi zmdi-close-circle-o zmdi-hc-lg" />
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    <div className="col-12 jr-card-body row my-3">
                      <div className="col-12 col-lg-4 d-flex align-items-center jr-card-header mb-0" />
                      <CardText className="col-12 col-xl-8 col-lg-12 row d-flex align-items-center">
                        <h4 className="col-4 col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block">
                          {" "}
                          CURRENT{" "}
                        </h4>
                        <h4 className="col-4 col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block">
                          {" "}
                          DESIRED{" "}
                        </h4>
                        <h4 className="col-4 col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block">
                          UPDATE
                        </h4>
                      </CardText>
                    </div>

                    <div className="col-12 jr-card-body row my-3">
                      <div className="col-12 col-lg-4 d-flex align-items-center jr-card-header mb-0">
                        <h4 className="card-heading d-inline-block">
                          {" "}
                          Depth of pit (mms){" "}
                        </h4>
                      </div>
                      <CardText className="col-12 col-xl-8 col-lg-12 row d-flex align-items-center">
                        <h4 className="col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0">
                          {this.state.pitDepth}
                        </h4>
                        <h4 className="col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0">
                          NA
                        </h4>
                        <div className="col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0">
                          <input
                            className="inputContainer"
                            type="text"
                            placeholder=""
                            onChange={this.onChangeDepth}
                            value={this.state.depthOfPit}
                          />
                        </div>
                      </CardText>
                    </div>

                    <div className="col-12 jr-card-body row my-3">
                      <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center jr-card-header mb-0">
                        <h4 className="card-heading d-inline-block">
                          {" "}
                          Sensor read interval (secs){" "}
                        </h4>
                        <div className="col-3 text-right card-heading d-inline-block my-0">
                          {this.renderImage(sensorReadActive)}
                        </div>
                      </div>
                      <CardText className="col-12 col-xl-8 col-lg-12 row d-flex align-items-center">
                        <div className="col-lg-4 col-xl-4 col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.sensors &&
                              configurationValues.sensors.reported}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.sensors &&
                              this.formatDate(
                                configurationValues.sensors.lastReportedAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.sensors &&
                              configurationValues.sensors.status ===
                                "PENDING" &&
                              configurationValues.sensors.desired}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.sensors &&
                              configurationValues.sensors.status ===
                                "PENDING" &&
                              this.formatDate(
                                configurationValues.sensors.lastDesiredAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0">
                          <input
                            className="inputContainer"
                            type="text"
                            placeholder=""
                            onChange={this.onChangeSensorRead}
                            value={this.state.sensorReadInterval}
                          />
                        </div>
                      </CardText>
                    </div>

                    <div className="col-12 jr-card-body row my-3">
                      <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center jr-card-header mb-0">
                        <h4 className="card-heading d-inline-block">
                          {" "}
                          Transmit interval (secs){" "}
                        </h4>
                        <div className="col-3 text-right card-heading d-inline-block my-0">
                          {this.renderImage(transmitIntervalActive)}
                        </div>
                      </div>
                      <CardText className="col-12 col-xl-8 col-lg-12 row d-flex align-items-center">
                        <div className="col-lg-4 col-xl-4  col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.network &&
                              configurationValues.network.reported}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.network &&
                              this.formatDate(
                                configurationValues.network.lastReportedAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4  col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.network &&
                              configurationValues.network.status ===
                                "PENDING" &&
                              configurationValues.network.desired}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.network &&
                              configurationValues.network.status ===
                                "PENDING" &&
                              configurationValues.network.desired &&
                              this.formatDate(
                                configurationValues.network.lastDesiredAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4  col-sm-4 text-center card-heading d-inline-block my-0">
                          <input
                            className="inputContainer"
                            type="text"
                            placeholder=""
                            onChange={this.onChangeTransmitInterval}
                            value={this.state.transmitInterval}
                          />
                        </div>
                      </CardText>
                    </div>

                    <div className="col-12 jr-card-body row my-3">
                      <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center jr-card-header mb-0">
                        <h4 className="card-heading d-inline-block">
                          {" "}
                          Battery level read interval (secs){" "}
                        </h4>
                        <div className="col-3 text-right card-heading d-inline-block my-0">
                          {this.renderImage(batteryReadActive)}
                        </div>
                      </div>
                      <CardText className="col-12 col-xl-8 col-lg-12 row d-flex align-items-center">
                        <div className="col-lg-4 col-xl-4  col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.maintenance &&
                              configurationValues.maintenance.reported}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.maintenance &&
                              this.formatDate(
                                configurationValues.maintenance.lastReportedAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4  col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.maintenance &&
                              configurationValues.maintenance.status ===
                                "PENDING" &&
                              configurationValues.maintenance.desired}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.maintenance &&
                              configurationValues.maintenance.status ===
                                "PENDING" &&
                              configurationValues.maintenance.desired &&
                              this.formatDate(
                                configurationValues.maintenance.lastDesiredAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0">
                          <input
                            className="inputContainer"
                            type="text"
                            placeholder=""
                            onChange={this.onChangeBatteryLevelRead}
                            value={this.state.batteryReadInterval}
                          />
                        </div>
                      </CardText>
                    </div>

                    <div className="col-12 jr-card-body row my-3">
                      <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center jr-card-header mb-0">
                        <h4 className="card-heading d-inline-block">
                          {" "}
                          Current sensor read interval (secs){" "}
                        </h4>
                        <div className="col-3 text-right card-heading d-inline-block my-0">
                          {this.renderImage(currentSensorActive)}
                        </div>
                      </div>
                      <CardText className="col-12 col-xl-8 col-lg-12 row d-flex align-items-center">
                        <div className="col-lg-4 col-xl-4 col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.current &&
                              configurationValues.current.reported}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.current &&
                              this.formatDate(
                                configurationValues.current.lastReportedAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.current &&
                              configurationValues.current.status ===
                                "PENDING" &&
                              configurationValues.current.desired}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.current &&
                              configurationValues.current.status ===
                                "PENDING" &&
                              configurationValues.current.desired &&
                              this.formatDate(
                                configurationValues.current.lastDesiredAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0">
                          <input
                            className="inputContainer"
                            type="text"
                            placeholder=""
                            onChange={this.onChangeCurrentSensorRead}
                            value={this.state.currentSensorRead}
                          />
                        </div>
                      </CardText>
                    </div>

                    <div className="col-12 jr-card-body row my-3">
                      <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center0 jr-card-header mb-0">
                        <h4 className="card-heading d-inline-block">
                          {" "}
                          Number of temperature probes{" "}
                        </h4>
                        <div className="col-3 text-right card-heading d-inline-block my-0">
                          {this.renderImage(temperatureProbeActive)}
                        </div>
                      </div>
                      <CardText className="col-12 col-xl-8 col-lg-12 row d-flex align-items-center">
                        <div className="col-lg-4 col-xl-4 col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.probes &&
                              configurationValues.probes.reported}
                          </h4>

                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.probes &&
                              this.formatDate(
                                configurationValues.probes.lastReportedAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4">
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.probes &&
                              configurationValues.probes.status === "PENDING" &&
                              configurationValues.probes.desired}
                          </h4>
                          <h4 className="col-12 text-center card-heading d-inline-block my-0">
                            {configurationValues.probes &&
                              configurationValues.probes.status === "PENDING" &&
                              configurationValues.probes.desired &&
                              this.formatDate(
                                configurationValues.probes.lastDesiredAt
                              )}
                          </h4>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0">
                          <input
                            className="inputContainer"
                            type="text"
                            placeholder=""
                            onChange={this.onChangeTemperatureProbes}
                            value={this.state.temperatureProbes}
                          />
                        </div>
                      </CardText>
                    </div>
                  </div>
                </div>
                {/* <div className="col-12 col-sm-6 col-lg-6">
                  <div className="jr-card">
                    <div className="row h-100">
                      <div className="row mx-0">
                        <div className="jr-card-header ml-2">
                          <h3 className="card-heading d-inline-block">
                            {" "}
                            Number Of Techs Onsite{" "}
                          </h3>
                        </div>
                      </div>
                      <div className="row w-100 mx-0">
                        <div className="inner-height">
                          <div className="col-12 jr-card-body set-background">
                            <div className="info-card d-inline-flex w-100">
                              <div className="col left-text w-50 float-left px-0">
                                <h5 className="t-cost">
                                </h5>
                              </div>
                              <div className="col text-right w-50 float-right px-0">
                                <img
                                  src="../../../../../assets/images/hse.png"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* <div className="col-12 col-sm-6 col-lg-6">
                  <div className="jr-card">
                    <div className="row h-100">
                      <div className="row mx-0">
                        <div className="jr-card-header ml-2">
                          <h3 className="card-heading d-inline-block">
                            {" "}
                            Number Of Devices with Active Notifications{" "}
                          </h3>
                        </div>
                      </div>
                      <div className="row w-100 mx-0">
                        <div className="inner-height">
                          <div className="col-12 jr-card-body set-background">
                            <div className="info-card d-inline-flex w-100">
                              <div className="col left-text w-50 float-left px-0">
                                <h5 className="t-cost"></h5>
                              </div>
                              <div className="col text-right w-50 float-right px-0">
                                <img
                                  src="../../../../../assets/images/ico-notification.png"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* <div className="col-12 col-sm-6 col-lg-6">
                  <div className="jr-card">
                    <div className="row h-100">
                      <div className="row mx-0">
                        <div className="jr-card-header ml-2">
                          <h3 className="card-heading d-inline-block">
                            {" "}
                            Number Of Devices with Closed Notifications{" "}
                          </h3>
                        </div>
                      </div>
                      <div className="row w-100 mx-0">
                        <div className="inner-height">
                          <div className="col-12 jr-card-body set-background">
                            <div className="info-card d-inline-flex w-100">
                              <div className="col left-text w-50 float-left px-0">
                                <h5 className="t-cost">
                                </h5>
                              </div>
                              <div className="col text-right w-50 float-right px-0">
                                <img
                                  src="../../../../../assets/images/ico-notification.png"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ symbioticReducer }) => {
  return {
    deviceId: symbioticReducer.deviceId,
  };
};

const mapDispatchToProps = (dispatch) => {};

export default connect(mapStateToProps, mapDispatchToProps)(Config);



// WEBPACK FOOTER //
// ./app/routes/configuration/index.js